/* The home page programs section (ScrollStory steps).
   ----------------------------------------------------------------------
   Since 2026-10-06 the site offers the owner's five programs, defined
   once in src/data/offer.js: Finance & Accounting, AI-Powered Business,
   Coding with AI, Japanese Mental Arithmetic, Arts & Craft. Elite
   Development (1-on-1) and Sports Performance were taken off the site
   "for now"; git history before that date has their data.

   One step per program, one distinct photo each (never repeated in the
   story). Chips come from existing copy only. A program with its own
   page links there; the others link to their card on /programs.

   TRILINGUAL: every copy field is a { en, ar, ru } triple; ScrollStory
   resolves them itself, so callers pass the raw export through. */

import { PROGRAMS, SECTION } from "./offer";

const EIGHT = { en: "8 sessions", ar: "8 جلسات", ru: "8 занятий" };
const LEARN_MORE = { en: "Learn more", ar: "اعرف المزيد", ru: "Подробнее" };

export const PROGRAM_STEPS = PROGRAMS.map((p) => ({
  eyebrow:  p.eyebrow,
  title:    p.name,
  body:     p.text,
  chips:    [p.eyebrow, EIGHT, SECTION[p.group]],
  image:    `${p.photo.src}.jpg`,
  imageAlt: p.photo.alt,
  cta:      { label: LEARN_MORE, href: p.page || `/programs#${p.id}` },
}));
